import cx from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { formatSecondsToMMSS } from "./helper";
import style from "./StartVoteWindow.module.css";

export type StartVoteWindowVote = {
    UID: string;
    duration: number;
    creatorName: string;
};

type StartVoteWindowProps = {
    onClose: () => void;
    onAccept: () => void;
    vote: StartVoteWindowVote;
};

export function StartVoteWindow({ vote, onClose, onAccept }: StartVoteWindowProps) {
    const { t } = useTranslation();
    const handleAccept = () => {
        onAccept();
        onClose();
    };
    return (
        <div className={style.startVoteWindowWrapper}>
            <div className={style.startVoteWindow}>
                <div className={style.header}>
                    <h2 className={style.title}>{t("vote.startTitle")}</h2>
                    <p className={style.titleDescription}>
                        {t("vote.hostedBy", { name: vote.creatorName })}
                    </p>
                    <button
                        onMouseUp={onClose}
                        className={cx(style.close, "button", "button--close")}
                        type="button"
                        aria-label={t("common.close")}
                    />
                </div>
                <div className={style.details}>
                    <p className={style.detailsText}>{t("vote.timeForVote")}</p>
                    <p className={style.detailsTimer}>{formatSecondsToMMSS(vote.duration)}</p>
                </div>
                <div className={style.buttons}>
                    <button
                        onMouseUp={handleAccept}
                        type="button"
                        className={cx("button", "button--primary")}
                    >
                        {t("vote.join")}
                    </button>
                    <button onMouseUp={onClose} type="button" className="button">
                        {t("vote.skip")}
                    </button>
                </div>
            </div>
        </div>
    );
}
